import type { ExpectedConversation } from '../../../../../functions/tests/eval/phase1/types'

/** Deterministic palette for speaker bubbles. "me" is always primary-tinted. */
const FRIEND_PALETTE = [
  'bg-slate-200 text-slate-900 dark:bg-slate-700 dark:text-slate-100',
  'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100',
  'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-100',
  'bg-rose-100 text-rose-900 dark:bg-rose-900/40 dark:text-rose-100',
  'bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-100',
]

function bubbleClasses(speaker: string): { bubble: string; align: string } {
  if (speaker === 'me') {
    return { bubble: 'bg-primary-500 text-white', align: 'self-end' }
  }
  const match = speaker.match(/^friend\s+(\d+)$/i)
  const idx = match ? Math.max(0, parseInt(match[1], 10) - 1) : 0
  return {
    bubble: FRIEND_PALETTE[idx % FRIEND_PALETTE.length],
    align: 'self-start',
  }
}

export function TurnsAsBubbles({
  expected,
}: {
  expected: ExpectedConversation
}) {
  return (
    <div className="flex flex-col gap-2">
      {expected.turnSpeakers.map((speaker, i) => {
        const { bubble, align } = bubbleClasses(speaker)
        return (
          <div key={i} className={`flex flex-col max-w-[88%] ${align}`}>
            <span className="text-xs text-slate-500 dark:text-slate-400 px-2 mb-0.5">
              {speaker}
            </span>
            <div
              className={`rounded-2xl px-3 py-2 text-sm leading-snug whitespace-pre-wrap break-words ${bubble}`}
            >
              {expected.turnMessages[i] ?? ''}
            </div>
          </div>
        )
      })}
    </div>
  )
}
